import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { accessoriesVersionWithLoaderRegExp } from 'z3k-parser/model/z3k-config/accessoires-version';
export var IOExtension;
(function (IOExtension) {
    //добавь в zont.stats.utils.IOExtensionType
    let Type;
    (function (Type) {
        Type[Type["ZE66"] = 0] = "ZE66";
        Type[Type["CE_2"] = 1] = "CE_2";
        Type[Type["HUMIDITY_TEMP_SENSOR"] = 2] = "HUMIDITY_TEMP_SENSOR";
        Type[Type["TEMP_SENSOR"] = 3] = "TEMP_SENSOR";
        Type[Type["BUILTIN_BOARD"] = 4] = "BUILTIN_BOARD";
        Type[Type["ZE88"] = 5] = "ZE88";
        Type[Type["ZE44"] = 6] = "ZE44";
        Type[Type["ZE22"] = 7] = "ZE22";
        Type[Type["ZE8482"] = 9] = "ZE8482";
        Type[Type["HW_ext_board_ZE_03_SOCKETS"] = 10] = "HW_ext_board_ZE_03_SOCKETS";
        Type[Type["HW_ext_board_ZE_00_GATEWAY"] = 11] = "HW_ext_board_ZE_00_GATEWAY";
        Type[Type["RADIO_RELAY"] = 255] = "RADIO_RELAY";
    })(Type = IOExtension.Type || (IOExtension.Type = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["K_LINE_VIA_RS485_GATEWAY_FLAG"] = 1] = "K_LINE_VIA_RS485_GATEWAY_FLAG";
        Flags[Flags["RS485_VIA_UDP_GATEWAY_FLAG"] = 2] = "RS485_VIA_UDP_GATEWAY_FLAG";
        Flags[Flags["K_LINE_VIA_UDP_GATEWAY_FLAG"] = 4] = "K_LINE_VIA_UDP_GATEWAY_FLAG";
    })(Flags = IOExtension.Flags || (IOExtension.Flags = {}));
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["EXT_BOARD_INIT_FLAG"] = 1] = "EXT_BOARD_INIT_FLAG";
        StatusFlags[StatusFlags["NO_CONNECT_EVENT_FLAG"] = 2] = "NO_CONNECT_EVENT_FLAG";
        StatusFlags[StatusFlags["OUTCOMMING_MESSAGE_FLAG"] = 4] = "OUTCOMMING_MESSAGE_FLAG";
        StatusFlags[StatusFlags["INPUTS_EXTENDED_VALUE_FLAG"] = 8] = "INPUTS_EXTENDED_VALUE_FLAG";
        StatusFlags[StatusFlags["BOARD_WAS_RESET_FLAG"] = 16] = "BOARD_WAS_RESET_FLAG";
    })(StatusFlags = IOExtension.StatusFlags || (IOExtension.StatusFlags = {}));
    const hiddenTypesFromUser = [
        Type.HUMIDITY_TEMP_SENSOR,
        Type.TEMP_SENSOR,
        Type.BUILTIN_BOARD,
    ];
    function shownToUser(ioExt) {
        return ioExt.type == null || !hiddenTypesFromUser.includes(ioExt.type);
    }
    IOExtension.shownToUser = shownToUser;
    const typesWithoutCount = [
        Type.HUMIDITY_TEMP_SENSOR,
        Type.TEMP_SENSOR,
        Type.BUILTIN_BOARD,
        Type.HW_ext_board_ZE_00_GATEWAY,
    ];
    function countMaxAmount(ioExt) {
        return ioExt.type == null || !typesWithoutCount.includes(ioExt.type);
    }
    IOExtension.countMaxAmount = countMaxAmount;
    // Было сделано для снятия ограничений по количеству блоков для конкретного прибора!
    IOExtension.getVipSerialExpansionUnit = () => {
        return [
            '38b985807f79', // Кирьянов
        ];
    };
    /**
     * 2022.10.18
     * https://git.microline.ru/zont/server/-/issues/1395
     * Оставляем только разрешённое кол-во БР
     * Возникает проблема, что можно переставить строки местами, и настроить 2 БР,
     * но решили, что раз нашли - пусть пользуются. Т.к. проблем возникает много
     **/
    function filterIOExtensions(device_spec, io_extensions, serial) {
        const internal_io_extensions = io_extensions.filter((io_ext) => !IOExtension.countMaxAmount(io_ext));
        if (!device_spec.io.io_extensions_supported) {
            return internal_io_extensions;
        }
        if (device_spec.io.max_amount_io_extensions == null) {
            return io_extensions;
        }
        // Было сделано для снятия ограничений по количеству блоков для конкретного прибора!
        // не ограничивать блоки для некоторых приборов(z3k_config.login)
        if (IOExtension.getVipSerialExpansionUnit().includes(serial.toLowerCase())) {
            return io_extensions;
        }
        //Считаем НЕВСТРОЕННЫЕ блоки расширения
        const external_io_extensions = io_extensions.filter(IOExtension.countMaxAmount);
        //Начинаем фильтровать тогда
        if (external_io_extensions.length > device_spec.io.max_amount_io_extensions) {
            //Отрежем недозволенные блоки расширения
            const available_io_extensions = external_io_extensions.slice(0, device_spec.io.max_amount_io_extensions);
            return [...internal_io_extensions, ...available_io_extensions];
        }
        return io_extensions;
    }
    IOExtension.filterIOExtensions = filterIOExtensions;
    const hiddenTypesFromChosen = [
        Type.HUMIDITY_TEMP_SENSOR,
        Type.TEMP_SENSOR,
        Type.HW_ext_board_ZE_00_GATEWAY,
    ];
    function showInOptions(io_ext, device_spec) {
        return (device_spec.io.io_extensions_supported &&
            io_ext.type != null &&
            !hiddenTypesFromChosen.includes(io_ext.type));
    }
    IOExtension.showInOptions = showInOptions;
    function isBuiltIn(io_ext) {
        return io_ext.type === Type.BUILTIN_BOARD;
    }
    IOExtension.isBuiltIn = isBuiltIn;
    function isCE2(io_ext) {
        return io_ext.type === Type.CE_2;
    }
    IOExtension.isCE2 = isCE2;
    function isZE66(io_ext) {
        return io_ext.type === Type.ZE66;
    }
    IOExtension.isZE66 = isZE66;
    function isZEWithKLine(io_ext) {
        return io_ext.type
            ? [Type.ZE66, Type.ZE44, Type.ZE88].includes(io_ext.type)
            : false;
    }
    IOExtension.isZEWithKLine = isZEWithKLine;
    IOExtension.ml232RegExp = /(662)/;
    function isML232Thermostat(io_ext) {
        return io_ext.device_version
            ? io_ext.device_version.match(IOExtension.ml232RegExp) != null
            : false;
    }
    IOExtension.isML232Thermostat = isML232Thermostat;
    IOExtension.RegExp640 = /^(640)/;
    function isBuiltInCoProcessorWithBoilerAdapters(io_ext) {
        return io_ext.device_version
            ? io_ext.device_version.match(IOExtension.RegExp640) != null
            : false;
    }
    IOExtension.isBuiltInCoProcessorWithBoilerAdapters = isBuiltInCoProcessorWithBoilerAdapters;
    function getHardwareAndSoftwareVersion(io_ext) {
        const match = io_ext.device_version?.match(accessoriesVersionWithLoaderRegExp);
        if (match) {
            const updater = match[1];
            const hardware_type = match[2];
            const firmware_version = match[3];
            return {
                hw: parseInt(hardware_type, 10),
                fw: parseInt(firmware_version, 10),
                updater: updater == '' ? undefined : updater,
            };
        }
        return { hw: -1, fw: -1 };
    }
    IOExtension.getHardwareAndSoftwareVersion = getHardwareAndSoftwareVersion;
    function canUpdate(io_ext) {
        const match = io_ext.device_version?.match(accessoriesVersionWithLoaderRegExp);
        if (match) {
            return match[1] == 'BL2';
        }
        return false;
    }
    IOExtension.canUpdate = canUpdate;
    IOExtension.get = createAccessors(arrayGetSet('io_extensions'), {
        name: 'Блок расширения',
        serial: '',
        rol_connection_lost: [],
        device_version: 'v0.0',
        setting_register: 0,
        is_new: true,
        bus_address: 0,
    });
})(IOExtension || (IOExtension = {}));
